import { useState, FC, useRef, useEffect, KeyboardEvent, MouseEvent, FocusEvent } from 'react'
import { useTranslation } from 'react-i18next'
import useOnClickOutside from 'use-onclickoutside'
import FormItem from 'antd/lib/form/FormItem'
import PerFlexRow from '../../../../components/custom_components/FlexRow'
import PerButtonCircle from '../../../../components/custom_components/ButtonCircle'
import PerSpacer from '../../../../components/custom_components/Spacer'
import PerText from '../../../../components/custom_components/Text'
import TextArea from 'antd/lib/input/TextArea'
import './NewNote.less'
import { SmartAvatar } from '../../../avatar/SmartAvatar'

interface Props {
  add: (text: string) => void
  employeeId: number
  firstName: string
  lastName: string
  date: string
}
export const NewNote: FC<Props> = ({ add, employeeId, firstName, lastName, date }) => {
  const [editMode, setEditMode] = useState(false)
  const [text, setText] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [t] = useTranslation()
  const divRef = useRef<HTMLDivElement>(null)
  const textareaRef = useRef<TextArea>(null)

  const validateInput = (value: string) => {
    const length = value ? value.trim().length : 0
    const result = length <= 1 ? t('formError.commentLength') : null

    setError(result)
    setText(value)

    return result === null
  }

  useOnClickOutside(divRef, () => {
    setEditMode(false)
    if (!!!text.length) {
      setError(null)
    }
  })

  const addNote = (event: KeyboardEvent<HTMLInputElement> | MouseEvent<any, any> | FocusEvent<any>) => {
    if (event.hasOwnProperty('keyCode') && (event as KeyboardEvent<HTMLInputElement>).keyCode) {
      event.preventDefault()
    }
    if (validateInput(text)) {
      add(text)
      setText('')
    } else if (text.length > 1) {
      setError(null)
    }
  }
  useEffect(() => {
    // This runs AFTER the first render, so the ref is set by now.
    if (editMode && textareaRef && textareaRef.current) {
      textareaRef.current.focus()
    }
  }, [editMode])

  return (
    <div ref={divRef}>
      <PerFlexRow align="top" className="per-newNote">
        <PerFlexRow align="middle" className="per-newNote--user">
          <SmartAvatar employeeId={employeeId} firstName={firstName} lastName={lastName} />
          <PerSpacer ml="xs" mr="l">
            <PerText fontWeight="bold">{firstName}</PerText>
            <PerText appearance="flowing-text" color="secondary">
              {date}
            </PerText>
          </PerSpacer>
        </PerFlexRow>

        <FormItem validateStatus={error ? 'error' : ''} help={error ? error : ''}>
          <TextArea
            name="text"
            ref={textareaRef}
            value={text || ''}
            onBlur={(event) => {
              if (!!text.length) {
                addNote(event)
              }
            }}
            onChange={({ target: { value } }) => {
              if (error) {
                validateInput(value)
              }
              setText(value)
            }}
            placeholder="Comment"
            data-e2e-newnote-input
          />
        </FormItem>

        <PerButtonCircle
          icon="add_stroke"
          variant="pastel"
          color="success"
          ml="xs"
          size="small"
          tooltip={t('okr.objective.notes.add')}
          onClick={(event) => {
            addNote(event)
          }}
          data-e2e-addnote-button
        />
      </PerFlexRow>
    </div>
  )
}
